<template>
    <div v-if="display" class="row">
        <div class="col">
            <SubSection title="Do you need financial advice?" :show-help="false">
                <p>
                    This model is for information only. Call us for an initial meeting at our expense to discuss your plans
                    and start saving for a brighter financial future.
                </p>
                <p>
                    <strong>Call:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> 0800 068 8214 &nbsp;&nbsp;&nbsp;<small class="text-muted">All calls are recorded for business purposes</small>
                </p>
                <p>
                    <strong>Email:&nbsp;&nbsp;</strong> <a href="mailto:clientservices@origenfs.co.uk">clientservices@origenfs.co.uk</a>
                </p>
                <p>
                    Origen is one of the UK's leading national financial advisers, with a history of providing advice for
                    140 years. We support people like you every day and we have advisers across the UK who are here 
                    to help you. Our advice is based on your own personal circumstances, aspirations and financial objectives.
                </p>
                <p><img src="/Content/images/origen/origen-award-strip.png" class="img-responsive" alt="Origen Awards" style="width: 75%" /></p>
            </SubSection>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";

const store = useStore();
const display = ref(false);

onMounted(() => {
    display.value = store.state.configuration.finishDisplaysFinancialAdvice;
});

</script>
